import AppPreviewModal from '@components/class-invoice/AppPreviewModal';
import { usePayment } from '@hooks/payment';
import { ProductSelectedOptionItem } from '@models/commerce';
import { ProductModel, QuestionOptionEditModel } from '@models/product';
import React from 'react';
import CommercePayment from './CommercePayment';
import CommercePaymentComplete from './CommercePaymentComplete';

interface CommercePaymentModalProps {
  open?: boolean;
  product?: ProductModel;
  totalFee: number;
  selectedOptions?: ProductSelectedOptionItem[];
  qnaOptions?: QuestionOptionEditModel[];
  onClickBack?: () => void;
  onConfirm?: () => void;
  onChangeQnaOptions?: (options: QuestionOptionEditModel[]) => void;
  collectQnaInPayment?: boolean;
}

export const CommercePaymentModal: React.FC<CommercePaymentModalProps> = (props) => {
  const payment = usePayment();
  const { open, product, totalFee, selectedOptions, onConfirm } = props;

  return (
    <AppPreviewModal
      title={'결제하기'}
      open={open}
      height={0}
      width={480}
      hideRightNaviButton
      onLeftNaviButtonClick={() => {
        props.onClickBack && props.onClickBack();
      }}>
      {payment.status === 'done' && payment.paymentStatement && (
        <CommercePaymentComplete paymentStatement={payment.paymentStatement} onConfirm={onConfirm} />
      )}
      {payment.status !== 'done' && (
        <CommercePayment
          open={open}
          product={product}
          totalFee={totalFee}
          selectedOptions={selectedOptions}
          qnaOptions={props.qnaOptions}
          collectQnaInPayment={props.collectQnaInPayment}
          onChangeQnaOptions={props.onChangeQnaOptions}
          onConfirm={onConfirm}></CommercePayment>
      )}
    </AppPreviewModal>
  );
};
